document.addEventListener('DOMContentLoaded', function () {

  /* ---- REVEAL ON SCROLL ---- */
  var revEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('v'); obs.unobserve(e.target); } });
    }, { threshold: .12 });
    revEls.forEach(function (el) { obs.observe(el); });
  } else { revEls.forEach(function (el) { el.classList.add('v'); }); }

  /* ---- MOBILE MENU ---- */
  var ham = document.getElementById('hamburger');
  var mob = document.getElementById('mobileMenu');
  if (ham && mob) ham.addEventListener('click', function () {
    mob.classList.toggle('open');
    ham.classList.toggle('open');
  });

  /* ---- PRODUCT GALLERY ---- */
  window.switchImg = function (thumb, src) {
    document.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
    var main = document.getElementById('mainImgEl');
    if (main) main.src = src;
  };

  /* ---- FAQ ACCORDION ---- */
  window.toggleFaq = function (el) {
    var item = el.closest('.faq-item');
    var wasOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(function (i) { i.classList.remove('open'); });
    if (!wasOpen) item.classList.add('open');
  };

  /* ---- CART DRAWER ---- */
  var drawer = document.getElementById('cartDrawer');
  var overlay = document.getElementById('cartOverlay');
  window.openCart = function () { if (drawer) drawer.classList.add('open'); if (overlay) overlay.classList.add('open'); document.body.style.overflow = 'hidden'; refreshCart(); };
  window.closeCart = function () { if (drawer) drawer.classList.remove('open'); if (overlay) overlay.classList.remove('open'); document.body.style.overflow = ''; };

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function updateCount(n) {
    document.querySelectorAll('.cart-count').forEach(function (b) {
      b.textContent = n; b.classList.toggle('has-items', n > 0);
    });
  }
  function renderDrawer(cart) {
    var body = document.getElementById('cartDrawerBody');
    var footer = document.getElementById('cartDrawerFooter');
    if (!body) return;
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cart-empty"><div class="cart-empty-ic">🛒</div><h3>Your cart is empty</h3><p>Add a cooling mat to get started.</p></div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    var html = '';
    cart.items.forEach(function (item) {
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="cart-item-variant">' + item.variant_title + '</div>' : '';
      html += '<div class="cart-item">' +
        '<div class="cart-item-img"><img src="' + (item.image || '') + '" alt=""></div>' +
        '<div style="flex:1"><div class="cart-item-name">' + item.product_title + '</div>' + variant +
        '<div class="cart-item-bottom"><span class="cart-item-price">' + money(item.line_price) + '</span>' +
        '<div class="cart-qty"><button onclick="cartChange(' + item.variant_id + ',' + (item.quantity - 1) + ')">−</button><span>' + item.quantity + '</span><button onclick="cartChange(' + item.variant_id + ',' + (item.quantity + 1) + ')">+</button>' +
        '<button class="cart-rm" onclick="cartChange(' + item.variant_id + ',0)">✕</button></div></div></div></div>';
    });
    body.innerHTML = html;
    if (footer) { footer.style.display = 'block'; var sub = document.getElementById('cartSubtotal'); if (sub) sub.textContent = money(cart.total_price); }
  }
  function refreshCart() { fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { updateCount(cart.item_count); renderDrawer(cart); }).catch(function () {}); }
  window.cartChange = function (id, q) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: q }) })
      .then(function (r) { return r.json(); }).then(function (cart) { updateCount(cart.item_count); renderDrawer(cart); });
  };

  /* initial cart count */
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { updateCount(cart.item_count); }).catch(function () {});

  /* ---- PRODUCT VARIANT LOGIC ---- */
  if (window.productVariants && window.productVariants.length) {
    if (!window.selectedOptions) window.selectedOptions = window.productVariants[0].options.slice();
    window.productPageQty = 1;
    window.changeProductQty = function (d) {
      window.productPageQty = Math.max(1, window.productPageQty + d);
      var el = document.getElementById('productQtyDisplay'); if (el) el.textContent = window.productPageQty;
      var input = document.getElementById('productQtyInput'); if (input) input.value = window.productPageQty;
    };
    window.selectOptionValue = function (btn, optionIndex, value) {
      var group = btn.closest('.pdp-sizes');
      if (group) group.querySelectorAll('.pdp-size').forEach(function (b) { b.classList.remove('on'); });
      btn.classList.add('on');
      window.selectedOptions[optionIndex] = value;
      var labelEl = document.getElementById('optVal' + (optionIndex + 1));
      if (labelEl) labelEl.textContent = value;
      updateVariantMatch();
    };
    function updateVariantMatch() {
      var matched = window.productVariants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === window.selectedOptions[i]; });
      });
      if (!matched) return;
      var idEl = document.getElementById('productVariantId'); if (idEl) idEl.value = matched.id;
      var priceEl = document.getElementById('pdPriceMain'); if (priceEl) priceEl.textContent = '$' + (matched.price / 100).toFixed(2);
      var ogEl = document.getElementById('pdPriceOg');
      if (ogEl && matched.compare_at_price && matched.compare_at_price > matched.price) ogEl.textContent = '$' + (matched.compare_at_price / 100).toFixed(2);
      var btn = document.getElementById('addToCartBtn');
      if (btn) { btn.disabled = !matched.available; btn.style.opacity = matched.available ? '1' : '.5'; }
      if (matched.featured_image) { var img = document.getElementById('mainImgEl'); if (img) img.src = matched.featured_image.src; }
    }
  }

  /* ---- CART PAGE ---- */
  window.updateCartPage = function (id, q) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: q }) })
      .then(function () { window.location.reload(); });
  };


  /* ---- HERO OFFER COUNTDOWN ---- */
  (function () {
    var h = document.getElementById('ohH'), m = document.getElementById('ohM'), s = document.getElementById('ohS');
    if (!h || !m || !s) return;
    var WINDOW = 3 * 60 * 60 * 1000;
    var key = 'pn_offer_deadline';
    var deadline;
    try { deadline = sessionStorage.getItem(key); } catch (e) { deadline = null; }
    var now = Date.now();
    if (!deadline || isNaN(+deadline) || +deadline < now) {
      deadline = now + WINDOW;
      try { sessionStorage.setItem(key, deadline); } catch (e) {}
    } else { deadline = +deadline; }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) { deadline = Date.now() + WINDOW; try { sessionStorage.setItem(key, deadline); } catch (e) {} diff = WINDOW; }
      var hrs = Math.floor(diff / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      h.textContent = pad(hrs); m.textContent = pad(mins); s.textContent = pad(secs);
    }
    tick();
    setInterval(tick, 1000);
  })();


  /* ---- BUNDLE & SAVE ROAMING TOAST ---- */
  (function () {
    var toast = document.getElementById('bundleToast');
    if (!toast) return;
    function showCycle() {
      toast.classList.add('show');
      setTimeout(function () { toast.classList.remove('show'); }, 5000); // visible 5s
    }
    // first appearance after 6s, then every ~18-26s (randomized)
    setTimeout(function () {
      showCycle();
      setInterval(function () { showCycle(); }, 18000 + Math.floor(Math.random() * 8000));
    }, 6000);
  })();

});
